module.exports = __webpack_public_path__ + "static/media/LEFTKOOS.20a3b9d2.pdf";